/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

export interface IPasswordResetLoadingMessage {
    className: string;
    message: string;
}

const PasswordResetLoadingMessage: React.FC<IPasswordResetLoadingMessage> = ({ className, message }) => (
    <div className={`${className}__loading-message`} >
        {message}
    </div>
);

export default PasswordResetLoadingMessage;
